/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Swarmind API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ApiOpenAIChatCompletionsInput } from '../models';
// @ts-ignore
import { ApiOpenAIChatCompletionsOutput } from '../models';
// @ts-ignore
import { ApiOpenAIImagesGenerationsInput } from '../models';
// @ts-ignore
import { ApiOpenAIImagesGenerationsOutput } from '../models';
// @ts-ignore
import { RestErrResponse } from '../models';
// @ts-ignore
import { SchemaModelsDataResponse } from '../models';
/**
 * LocalAIApi - axios parameter creator
 * @export
 */
export const LocalAIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * OpenAI chat completions request
         * @summary Chat completions
         * @param {string} pool 
         * @param {ApiOpenAIChatCompletionsInput} [apiOpenAIChatCompletionsInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        localAIChatCompletions: async (pool: string, apiOpenAIChatCompletionsInput?: ApiOpenAIChatCompletionsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pool' is not null or undefined
            assertParamExists('localAIChatCompletions', 'pool', pool)
            const localVarPath = `/lai/{pool}/v1/chat/completions`
                .replace(`{${"pool"}}`, encodeURIComponent(String(pool)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiOpenAIChatCompletionsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * OpenAI model list request
         * @summary Models
         * @param {string} pool 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        localAIGetModels: async (pool: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pool' is not null or undefined
            assertParamExists('localAIGetModels', 'pool', pool)
            const localVarPath = `/lai/{pool}/v1/models`
                .replace(`{${"pool"}}`, encodeURIComponent(String(pool)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * OpenAI image generations request
         * @summary Image generations
         * @param {string} pool 
         * @param {ApiOpenAIImagesGenerationsInput} [apiOpenAIImagesGenerationsInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        localAIImageGenerations: async (pool: string, apiOpenAIImagesGenerationsInput?: ApiOpenAIImagesGenerationsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pool' is not null or undefined
            assertParamExists('localAIImageGenerations', 'pool', pool)
            const localVarPath = `/lai/{pool}/v1/images/generations`
                .replace(`{${"pool"}}`, encodeURIComponent(String(pool)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiOpenAIImagesGenerationsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocalAIApi - functional programming interface
 * @export
 */
export const LocalAIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocalAIApiAxiosParamCreator(configuration)
    return {
        /**
         * OpenAI chat completions request
         * @summary Chat completions
         * @param {string} pool 
         * @param {ApiOpenAIChatCompletionsInput} [apiOpenAIChatCompletionsInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async localAIChatCompletions(pool: string, apiOpenAIChatCompletionsInput?: ApiOpenAIChatCompletionsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpenAIChatCompletionsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.localAIChatCompletions(pool, apiOpenAIChatCompletionsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LocalAIApi.localAIChatCompletions']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * OpenAI model list request
         * @summary Models
         * @param {string} pool 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async localAIGetModels(pool: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchemaModelsDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.localAIGetModels(pool, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LocalAIApi.localAIGetModels']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * OpenAI image generations request
         * @summary Image generations
         * @param {string} pool 
         * @param {ApiOpenAIImagesGenerationsInput} [apiOpenAIImagesGenerationsInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async localAIImageGenerations(pool: string, apiOpenAIImagesGenerationsInput?: ApiOpenAIImagesGenerationsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpenAIImagesGenerationsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.localAIImageGenerations(pool, apiOpenAIImagesGenerationsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LocalAIApi.localAIImageGenerations']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LocalAIApi - factory interface
 * @export
 */
export const LocalAIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocalAIApiFp(configuration)
    return {
        /**
         * OpenAI chat completions request
         * @summary Chat completions
         * @param {LocalAIApiLocalAIChatCompletionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        localAIChatCompletions(requestParameters: LocalAIApiLocalAIChatCompletionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpenAIChatCompletionsOutput> {
            return localVarFp.localAIChatCompletions(requestParameters.pool, requestParameters.apiOpenAIChatCompletionsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * OpenAI model list request
         * @summary Models
         * @param {LocalAIApiLocalAIGetModelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        localAIGetModels(requestParameters: LocalAIApiLocalAIGetModelsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SchemaModelsDataResponse> {
            return localVarFp.localAIGetModels(requestParameters.pool, options).then((request) => request(axios, basePath));
        },
        /**
         * OpenAI image generations request
         * @summary Image generations
         * @param {LocalAIApiLocalAIImageGenerationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        localAIImageGenerations(requestParameters: LocalAIApiLocalAIImageGenerationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpenAIImagesGenerationsOutput> {
            return localVarFp.localAIImageGenerations(requestParameters.pool, requestParameters.apiOpenAIImagesGenerationsInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocalAIApi - interface
 * @export
 * @interface LocalAIApi
 */
export interface LocalAIApiInterface {
    /**
     * OpenAI chat completions request
     * @summary Chat completions
     * @param {string} pool 
     * @param {ApiOpenAIChatCompletionsInput} [apiOpenAIChatCompletionsInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalAIApiInterface
     */
    localAIChatCompletions(pool: string, apiOpenAIChatCompletionsInput?: ApiOpenAIChatCompletionsInput, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpenAIChatCompletionsOutput>;

    /**
     * OpenAI model list request
     * @summary Models
     * @param {string} pool 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalAIApiInterface
     */
    localAIGetModels(pool: string, options?: RawAxiosRequestConfig): AxiosPromise<SchemaModelsDataResponse>;

    /**
     * OpenAI image generations request
     * @summary Image generations
     * @param {string} pool 
     * @param {ApiOpenAIImagesGenerationsInput} [apiOpenAIImagesGenerationsInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalAIApiInterface
     */
    localAIImageGenerations(pool: string, apiOpenAIImagesGenerationsInput?: ApiOpenAIImagesGenerationsInput, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpenAIImagesGenerationsOutput>;

}

/**
 * Request parameters for localAIChatCompletions operation in LocalAIApi.
 * @export
 * @interface LocalAIApiLocalAIChatCompletionsRequest
 */
export interface LocalAIApiLocalAIChatCompletionsRequest {
    /**
     * 
     * @type {string}
     * @memberof LocalAIApiLocalAIChatCompletions
     */
    readonly pool: string

    /**
     * 
     * @type {ApiOpenAIChatCompletionsInput}
     * @memberof LocalAIApiLocalAIChatCompletions
     */
    readonly apiOpenAIChatCompletionsInput?: ApiOpenAIChatCompletionsInput
}

/**
 * Request parameters for localAIGetModels operation in LocalAIApi.
 * @export
 * @interface LocalAIApiLocalAIGetModelsRequest
 */
export interface LocalAIApiLocalAIGetModelsRequest {
    /**
     * 
     * @type {string}
     * @memberof LocalAIApiLocalAIGetModels
     */
    readonly pool: string
}

/**
 * Request parameters for localAIImageGenerations operation in LocalAIApi.
 * @export
 * @interface LocalAIApiLocalAIImageGenerationsRequest
 */
export interface LocalAIApiLocalAIImageGenerationsRequest {
    /**
     * 
     * @type {string}
     * @memberof LocalAIApiLocalAIImageGenerations
     */
    readonly pool: string

    /**
     * 
     * @type {ApiOpenAIImagesGenerationsInput}
     * @memberof LocalAIApiLocalAIImageGenerations
     */
    readonly apiOpenAIImagesGenerationsInput?: ApiOpenAIImagesGenerationsInput
}

/**
 * LocalAIApi - object-oriented interface
 * @export
 * @class LocalAIApi
 * @extends {BaseAPI}
 */
export class LocalAIApi extends BaseAPI implements LocalAIApiInterface {
    /**
     * OpenAI chat completions request
     * @summary Chat completions
     * @param {LocalAIApiLocalAIChatCompletionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalAIApi
     */
    public localAIChatCompletions(requestParameters: LocalAIApiLocalAIChatCompletionsRequest, options?: RawAxiosRequestConfig) {
        return LocalAIApiFp(this.configuration).localAIChatCompletions(requestParameters.pool, requestParameters.apiOpenAIChatCompletionsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * OpenAI model list request
     * @summary Models
     * @param {LocalAIApiLocalAIGetModelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalAIApi
     */
    public localAIGetModels(requestParameters: LocalAIApiLocalAIGetModelsRequest, options?: RawAxiosRequestConfig) {
        return LocalAIApiFp(this.configuration).localAIGetModels(requestParameters.pool, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * OpenAI image generations request
     * @summary Image generations
     * @param {LocalAIApiLocalAIImageGenerationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalAIApi
     */
    public localAIImageGenerations(requestParameters: LocalAIApiLocalAIImageGenerationsRequest, options?: RawAxiosRequestConfig) {
        return LocalAIApiFp(this.configuration).localAIImageGenerations(requestParameters.pool, requestParameters.apiOpenAIImagesGenerationsInput, options).then((request) => request(this.axios, this.basePath));
    }
}

